// Storage keys for Device Auth (TV/QR code login)
export const TV_ACCESS_TOKEN_KEY = "tv_access_token";
export const TV_REFRESH_TOKEN_KEY = "tv_refresh_token";
export const TV_TOKEN_EXPIRES_AT_KEY = "tv_token_expires_at";

// Storage keys for Keycloak
export const KEYCLOAK_SESSION_ACTIVE_KEY = "keycloak_session_active";

// Storage keys for OAuth2 Capacitor
export const OAUTH2_ID_TOKEN_KEY = "id_token";
export const OAUTH2_REFRESH_TOKEN_KEY = "refresh_token";
export const OAUTH2_TOKEN_EXPIRE_TIME_KEY = "auth_token_expire_time";
export const OAUTH2_LOGOUT_IN_PROGRESS_KEY = "oauth2_logout_in_progress";
